import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import closeButtonDarkIcon from '../../../assets/svg/close-button-dark.svg'

import './index.sass'

export function Popup({ visible, onClose, children }) {
  if (!visible) return null

  return (
    <div className="popup">
      <div className="popup__content">
          <img src={closeButtonDarkIcon} alt="close" className="popup__close-img" onClick={onClose} />
          {children}
      </div>
    </div>
  )
}